import Vue from 'vue'

export default function (router) {
  Vue.swal({
    title: '<div style="color:#ed7d3e;">🚀 Novo Plano Enterprise disponível!</div>',
    html: `
          <div style="color:rgb(25, 48, 81); font-size: 18px;">
            <br>
            Olá!
            <br>
            Lançamos um pacote especial com novas funcionalidades:
            <br>
            <b>DTE, MIT, Parcelamentos Mei e novas integrações municipais.</b> Cada módulo possui valor individual.
            <br><br>
            Entre em contato com nosso suporte para saber mais.<br><br> Para clientes do Plano Exclusivo, o parcelamento MEI já está liberado e pode ser configurado diretamente no sistema.
            <br><br><br>
            <b>Atenciosamente, Equipe Monitor Contábil</b>
            </div>
    `,
    icon: 'warning',
    iconColor: '#ed7d3e',
    confirmButtonText: 'OK',
    buttonsStyling: false,
    width: '35%',
    customClass: {
      popup: 'swal-m',
      confirmButton: 'btn btn-primary mt-2',
    },
  }).then(result => {
    if (result.isDenied) {
      router.push({ name: 'empresa-view', query: { filtroRapido: 'ApenasCPF' } })
    }
  })
}
